module.exports = __webpack_public_path__ + "img/flower-left.439ff77a.png";